webpackJsonp([15],{

/***/ "2DLP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_ScrollMagic__ = __webpack_require__("A8vr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_ScrollMagic___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_ScrollMagic__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_TweenMax__ = __webpack_require__("+Uzz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_TweenMax___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_TweenMax__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_animation_gsap__ = __webpack_require__("+5V6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_animation_gsap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_animation_gsap__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      page: ''
    };
  },

  methods: {
    setTweens: function setTweens() {
      var slides = document.querySelectorAll('.animateIn');

      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(slides), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var slide = _step.value;

          new __WEBPACK_IMPORTED_MODULE_1_ScrollMagic___default.a.Scene({
            triggerElement: slide,
            triggerHook: 'onEnter'
          }).setTween(__WEBPACK_IMPORTED_MODULE_2_TweenMax___default.a.from(slide, 1, { y: 250, opacity: 0 })).addTo(window.scrollController);
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    }
  },
  created: function created() {
    var _this = this;

    window.api.get('get-pages/about').then(function (res) {
      _this.page = res.data.data.page;
    });
    window.api.get('get-pages-by-type/2').then(function (res) {
      _this.projects = res.data.data;
    }).then(function () {
      _this.setTweens();
    });
  }
});

/***/ }),

/***/ "aazn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('article',{staticClass:"branding page type-page status-publish hentry"},[_c('header',{directives:[{name:"lazy",rawName:"v-lazy:background-image",value:('https://api.alt-design.net/api/image/' + _vm.page.header_image[Math.floor(Math.random() * _vm.page.header_image.length)]),expression:"'https://api.alt-design.net/api/image/' + page.header_image[Math.floor(Math.random() * page.header_image.length)]",arg:"background-image"}],staticClass:"entry-header animateIn"},[_c('h1',{staticClass:"entry-title"},[_vm._v("Digital")])]),_vm._v(" "),_c('div',{staticClass:"entry-content animateIn wrapper"},[_c('h2',{staticClass:"alt-title"},[_vm._v("Where seamless functionality and usability meets crafted design.")]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('div',{staticClass:"view-work"},[_c('h2',{staticClass:"alt-title"},[_vm._v("View our Digital work")]),_vm._v(" "),_c('div',[_c('router-link',{staticClass:"button",attrs:{"to":"/work"}},[_vm._v("Work")])],1)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cols"},[_c('div',{staticClass:"col left"},[_c('p',{staticClass:"intro"},[_vm._v("All of our digital and web design projects are made to order based on your individual requirements. We can help you create an online experience that appeals to your users.\n                ")]),_vm._v(" "),_c('p',{staticClass:"intro"},[_vm._v("\n                    Whether it's a reliable e-commerce store or a simple gallery page our studio has the expertise to produce a site that is easy to find, looks good and works hard.")])]),_vm._v(" "),_c('div',{staticClass:"col right"},[_c('div',[_c('p',{staticClass:"intro"},[_vm._v("We consider:")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("Design & Development")]),_vm._v(" "),_c('li',[_vm._v("Responsive websites")]),_vm._v(" "),_c('li',[_vm._v("Content Management Systems")]),_vm._v(" "),_c('li',[_vm._v("E-commerce")]),_vm._v(" "),_c('li',[_vm._v("Web Design")]),_vm._v(" "),_c('li',[_vm._v("Email marketing")]),_vm._v(" "),_c('li',[_vm._v("Web apps")]),_vm._v(" "),_c('li',[_vm._v("Mobile")]),_vm._v(" "),_c('li',[_vm._v("Social Media")])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ey78":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Digital_vue__ = __webpack_require__("2DLP");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3ec0a1b7_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Digital_vue__ = __webpack_require__("aazn");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Digital_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3ec0a1b7_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Digital_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ })

});


// WEBPACK FOOTER //
// static/js/15.30c66d6619fb8771fd09.js